export default __webpack_public_path__ + "static/media/09.7f350ef0.png";